<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

  import ModalBS3 from '../ModalBS3.svelte';
  import Button from '../Button.svelte';
  import { onMount } from 'svelte';
  import { validateForm } from '../Form/utils.js';
  import ComboSelect from '../ComboSelect/ComboSelect.svelte';
  import MegaSelect from '../MegaSelect/MegaSelect.svelte';
  import CheckBox from '../CheckBox.svelte';
  import yup, { object, number } from 'yup';
  import { submit } from '../Form/utils.js';
  import Errors from '../Errors.svelte';
  import {get} from '../../utils.js';
  import {sgettext} from '../../i18n.js';

  export let title = sgettext('$$DRAFT_SEQUENCE_RISK_CONTROL$$');
  export let id = 'draftSequenceControlConfigurationForm';
  export let workSequenceId = null;

  export let actionUrl = `${PATH_PREFIX}/sw/api/draftsequencecontrolconfigurations/`; // hazards_and_controls:draftsequencecontrolconfiguration-list
  export let hazardOptionsUrl = `${PATH_PREFIX}/sw/api/applicable-branch-hazards-controls-grouped-by-energy-type-and-mechanism/`;
  export let severityOptionsUrl = `${PATH_PREFIX}/sw/api/severity/`; // hazards_and_controls:severity_options
  export let likelihoodOptionsUrl = `${PATH_PREFIX}/sw/api/likelihood/`; // hazards_and_controls:likelihood_options

  export let onSubmit = () => {
    builder.app.draftSequenceManager.loadContents({ id: workSequenceId });
  };
  export let editId = 0;

  let energyTypes = [];
  let hazardOptions = [];
  let controlOptions = [];
  let allSeverities = [];
  let severityOptions = [];
  let allLikelihoods = [];
  let likelihoodOptions = [];
  let isValid = true;
  let sending = false;
  let formErrors = null;
  let requireReload = false;
  let requiresConfirmation = false;

  let energyType = null;
  let mechanism = null;

  let initialSeverity = null;
  let initialLikelihood = null;

  let selectedSeverity = null;
  let selectedLikelihood = null;

  // let showGRCCode = false;

  let draftSequenceControlConfiguration = getDefault();

  let schema = object().shape({
    global_hazard: number()
      .required(sgettext('$$REQUIRED_FIELD$$'))
      .typeError(sgettext('$$REQUIRED_FIELD$$')),
    global_control: number()
      .required(sgettext('$$REQUIRED_FIELD$$'))
      .typeError(sgettext('$$REQUIRED_FIELD$$')),
  });

  let fieldIsValid = getDefaultFieldIsValid();
  $: isValidForm = mechanism && draftSequenceControlConfiguration.global_hazard
                    && draftSequenceControlConfiguration.global_control;

  $: if (editId) {
    getEditItem();
  } else {
    requiresConfirmation = false;
  }

  let getAllHazardsFromOptions = options => {
    let result = [];
    for (let oEnergyType of options) {
      for (let oMechanism of oEnergyType.mechanisms) {
        for (let oHazard of oMechanism.global_hazards) {
          let aHazard = {...oHazard};
          aHazard.energyType = {...oEnergyType};
          aHazard.mechanism = {...oMechanism};
          result.push({...aHazard});
        }
      }
    }
    return result;
  };

  function getDefaultFieldIsValid() {
    return {
      global_hazard: {
        isValid: true,
        errors: '',
      },
      global_control: {
        isValid: true,
        errors: '',
      },
    };
  }

  let isObjectIdChanged = (oldObject, newObject) => {
    return newObject?.id != oldObject?.id;
  };

  let handleSelectMechanism = (event, item) => {
    if (isObjectIdChanged(mechanism, event.detail)) {
      mechanism = {...event.detail};
      draftSequenceControlConfiguration.global_hazard = null;
      draftSequenceControlConfiguration.global_control = null;
      hazardOptions = [...mechanism.global_hazards];
      controlOptions = [];

      if (hazardOptions.length === 1) {
        draftSequenceControlConfiguration.global_hazard = hazardOptions[0].id;
        doSelectHazard(hazardOptions[0].id);
      }
    }
  };

  let handleClearMechanism = event => {
    mechanism = null;
    draftSequenceControlConfiguration.global_hazard = null;
    draftSequenceControlConfiguration.global_control = null;
    hazardOptions = getAllHazardsFromOptions(energyTypes);
    controlOptions = [];
  };

  let doSelectHazard = newGlobalHazardId => {
    let newGlobalHazard = getHazardFromId(newGlobalHazardId);
    if (newGlobalHazard.energyType) energyType = {...newGlobalHazard.energyType};
    if (newGlobalHazard.mechanism) mechanism = {...newGlobalHazard.mechanism};

    controlOptions = [...newGlobalHazard.global_controls];

    if (controlOptions.length === 1) {
      draftSequenceControlConfiguration.global_control = controlOptions[0].id;
    } else {
      draftSequenceControlConfiguration.global_control = null;
    }
  };

  async function handleHazardChanged(event) {
    formErrors = null;

    if (event.detail.value) {
      doSelectHazard(draftSequenceControlConfiguration.global_hazard);
    }
  }

  async function checkForDuplicate(event) {
    await validateHazardAndControlIsUnique(
      draftSequenceControlConfiguration.global_hazard,
      draftSequenceControlConfiguration.global_control
    );
  }

  // function toggleGRCCode(){
  //   showGRCCode = !showGRCCode;
  // }

  async function onSaveAndClose() {
    try {
      await validateForm(schema, draftSequenceControlConfiguration);
      await submitForm();

      if (!formErrors || formErrors.length == 0) {
        jQuery(`#${id}`).modal('hide');
        controlOptions = [];
        draftSequenceControlConfiguration = getDefault();
        onSubmit();
      }
    } catch (err) {
      isValid = false;
      if (err.inner) {
        err.inner.forEach((er) => {
          fieldIsValid[er.path].isValid = false;
          fieldIsValid[er.path].errors = er.message;
        });
      }
    }
  }

  async function submitForm() {
    sending = true;
    let method = 'POST';
    let url = actionUrl;
    if (editId) {
      method = 'PUT';
      url = `${actionUrl}${editId}/`;
    }

    draftSequenceControlConfiguration.work_sequence = workSequenceId;

    try {
      await submit(url, method, draftSequenceControlConfiguration);
      sending = false;
    } catch (error) {
      sending = false;

      if (error.hasOwnProperty('non_field_errors')) {
        formErrors = error;
      }
    }
  }

  async function onSaveAndCreate() {
    try {
      await validateForm(schema, draftSequenceControlConfiguration);
      await submitForm();
      if (!formErrors || formErrors.length == 0) {
        draftSequenceControlConfiguration = { ...getDefault() };
        requireReload = true;
        controlOptions = [];
      }
    } catch (err) {
      isValid = false;
      err.inner.forEach((er) => {
        fieldIsValid[er.path].isValid = false;
        fieldIsValid[er.path].errors = er.message;
      });
    }
  }

  function getDefault() {
    return {
      energyType: null,
      mechanism: null,
      global_hazard: null,
      global_control: null,
      contextual_severity: null,
      contextual_likelihood: null,
      contextual_residual_risk_rating: 0,
      risk_id: null,
      control_id: null,
      material_risk_flag: false,
      work_sequence: workSequenceId,
      valid: true,
      confirmed: true,
    };
  }

  async function getEditItem() {
    if (editId) {
      const response = await get(`${actionUrl}${editId}/`);

      if (response.ok) {
        const json = await response.json();
        draftSequenceControlConfiguration = { ...json };

        if (draftSequenceControlConfiguration.mechanism?.id) {
          getHazardOptionsFromMechanismId(
            draftSequenceControlConfiguration.mechanism.id
          );
          hazardOptions = getAllHazardsFromOptions(energyTypes);
        }

        if (draftSequenceControlConfiguration.global_hazard) {
          await getControlOptionsFromHazard(
            draftSequenceControlConfiguration.global_hazard
          );
        }
        requiresConfirmation = !draftSequenceControlConfiguration.confirmed;

        initialSeverity = allSeverities.find((j) => {
          return j.id === draftSequenceControlConfiguration.contextual_severity;
        });

        initialLikelihood = allLikelihoods.find((j) => {
          return j.id === draftSequenceControlConfiguration.contextual_likelihood;
        });
      }
    }
  }

  function handleClose() {
    draftSequenceControlConfiguration = getDefault();
    fieldIsValid = getDefaultFieldIsValid();
    isValid = true;
    formErrors = null;
    editId = null;

    if (requireReload) {
      onSubmit();
    }
  }

  async function getOptions(url) {
    const response = await get(url);

    if (response.ok) {
        const json = await response.json();
        energyTypes = json;
        hazardOptions = getAllHazardsFromOptions(energyTypes);
    }
  }

  function getHazardOptionsFromMechanismId(mechanismId) {
    hazardOptions = getAllHazardsFromOptions(energyTypes);

    for (let energyTypeOption of energyTypes) {
      for (let mechanismOption of energyTypeOption.mechanisms) {
        if (mechanismOption.id == mechanismId) {
          energyType = {...energyTypeOption};
          mechanism = {...mechanismOption};
          hazardOptions = [...mechanism.global_hazards];
          return;
        }
      }
    }
  }

  function getHazardFromId(hazardId) {
    for (let hazard of hazardOptions) {
      if (hazard.id === hazardId) {
        return hazard;
      }
    }
  }

  function getControlOptionsFromHazard(hazardId) {
    for (let hazard of hazardOptions) {
      if (hazard.id === hazardId) {
        controlOptions = [...hazard.global_controls];
        break;
      }
    }
  }

  async function validateHazardAndControlIsUnique(hazardId, controlId) {
    const response = await get(
      `${actionUrl}get_duplicates/${workSequenceId}/${hazardId}/${controlId}/`
    );

    let isUnique = true;

    if (response.status !== 404) {
      const matchingControlConfiguration = await response.json();

      if (matchingControlConfiguration.id !== editId) {
        isUnique = false;
      }
    }

    if (isUnique) {
      fieldIsValid.global_control.isValid = true;
      fieldIsValid.global_control.errors = '';
    } else {
      const errorMsg = gettext(
        '$$HAZARD_CONTROL_COMBINATION_ALREADY$$'
      );
      fieldIsValid.global_control.isValid = false;
      fieldIsValid.global_control.errors = errorMsg;
    }
  }

  async function getSeverityOptions(url) {
    const response = await get(url);
    const json = await response.json();

    allSeverities = json.map((j) => {
      return {
        ...j,
        name: `${j.sequence} - ${j.name} (${j.multiplier})`,
      };
    });

    severityOptions = allSeverities.filter((j) => {
      return !j.legacy
    });

  }

  async function getLikelihoodOptions(url) {
    const response = await get(url);
    const json = await response.json();

    allLikelihoods = json.map((j) => {
      return {
        ...j,
        name: `${j.sequence} - ${j.name} (${j.multiplier})`,
      };
    });

    likelihoodOptions = allLikelihoods.filter((j) => {
      return !j.legacy;
    });
  }

  function calculateResidualRisk(event) {
    let residual_risk_rating = '';

    if (selectedLikelihood && selectedSeverity) {
      residual_risk_rating =
        selectedSeverity.multiplier * selectedLikelihood.multiplier;
      if (residual_risk_rating) {
        draftSequenceControlConfiguration.contextual_residual_risk_rating = residual_risk_rating.toFixed(
          2
        );
      }
    }
  }

  onMount(async () => {
    await getOptions(hazardOptionsUrl);
    await getSeverityOptions(severityOptionsUrl);
    await getLikelihoodOptions(likelihoodOptionsUrl);

    jQuery(`#${id}`).on('hidden.bs.modal', function() {
      handleClose();
    });
  });
</script>

<style>
  .residual-risk {
    font-size: 24px;
  }

  .hidden {
    display: none;
  }

  .col-md-6 {
    padding-left: 0;
    padding-right: 0;
  }

  .form-row .col-md-6:first-child {
    padding-right: 10px;
  }

  .form-row .col-md-6:nth-child(2) {
    padding-left: 10px;
  }

  .form-group.checkbox :global(label) {
    margin: 0;
  }

  :global(.modal-footer button) {
    margin-left: 10px;
  }
</style>

<ModalBS3 {id} {title} backdrop={'static'} large={true}>
  <div slot="body">
    <form>
      <div class="form-group">
        <label for="mechanism" title="">{sgettext("$$MECHANISM_2$$")}</label>
            <MegaSelect
                id='mechanism'
                skipWindowEventId='draftSequenceControlConfigurationForm'
                options={energyTypes}
                headers={[
                    sgettext('$$HAZARDOUS_ENERGY$$'),
                    sgettext('$$WHAT_1$$'),
                    sgettext('$$SELECT_MECHANISM_1$$')
                ]}
                placeholder={sgettext('$$SEARCHSELECT_MECHANISM_$$')}
                noOptionsMessage={sgettext('$$RESULTS_FOUND$$')}
                isListGrouped={true}
                showImages={true}
                itemValueKey='id'
                itemLabelKey='name'
                groupLabelKey='name'
                groupDescriptionKey='description'
                getGroupImageUrl={group => group.icon ? group.icon.url : ''}
                groupItemsKey='mechanisms'
                selectedItem={mechanism}
                bind:groupOfSelectedItem={energyType}
                onSelectItem={handleSelectMechanism}
                onClear={handleClearMechanism}
                clearable={true}
                showTooltip={false}
                isWaiting={sending}
            />
      </div>
      <div class="form-group">
        <ComboSelect
          id="global_hazard"
          label={sgettext("$$RISK_1$$")}
          bind:options={hazardOptions}
          bind:value={draftSequenceControlConfiguration.global_hazard}
          bind:isValid={fieldIsValid.global_hazard.isValid}
          bind:errors={fieldIsValid.global_hazard.errors}
          on:changed={handleHazardChanged}
          searchable={true}
          {schema} />
      </div>
      <div class="form-group">
        <ComboSelect
          id="global_control"
          label={sgettext("$$CONTROL_1$$")}
          bind:options={controlOptions}
          bind:value={draftSequenceControlConfiguration.global_control}
          bind:isValid={fieldIsValid.global_control.isValid}
          bind:errors={fieldIsValid.global_control.errors}
          on:changed={checkForDuplicate}
          searchable={true}
          {schema} />
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <ComboSelect
            id="severity"
            label={sgettext("$$SEVERITY$$")}
            bind:options={severityOptions}
            bind:value={draftSequenceControlConfiguration.contextual_severity}
            bind:selected={selectedSeverity}
            on:changed={calculateResidualRisk} />
        </div>
        <div class="form-group col-md-6">
          <ComboSelect
            id="likelihood"
            label={sgettext("$$LIKELIHOOD$$")}
            options={likelihoodOptions}
            bind:selected={selectedLikelihood}
            bind:value={draftSequenceControlConfiguration.contextual_likelihood}
            on:changed={calculateResidualRisk} />
        </div>
      </div>
      {#if (initialSeverity && initialSeverity.legacy) || (initialLikelihood && initialLikelihood.legacy)}
      <div class="form-row">
        <div class="form-group col-md-6">
          {#if initialSeverity && initialSeverity.legacy}
            {sgettext('$$LEGACY_1$$')} {initialSeverity.name}
          {/if}
        </div>
        <div class="form-group col-md-6">
          {#if initialLikelihood && initialLikelihood.legacy}
            {sgettext('$$LEGACY_1$$')}  {initialLikelihood.name}
          {/if}
        </div>
      </div>
      {/if}
      <div class="form-group">
        <label>{sgettext('$$RESIDUAL_RISK_1$$')}</label>
        {#if draftSequenceControlConfiguration.contextual_residual_risk_rating}
          <span class="residual-risk">
            {draftSequenceControlConfiguration.contextual_residual_risk_rating}
          </span>
        {/if}
      </div>
      <div
        class="form-group checkbox"
        class:hidden={!requiresConfirmation}>
        <CheckBox
          id="confirmed"
          label={sgettext("$$CONFIRM_1$$")}
          bind:checked={draftSequenceControlConfiguration.confirmed}
          bootstrap3={true} />
      </div>

    </form>
    {#if formErrors}
      <Errors errors={formErrors} />
    {/if}
  </div>

  <div slot="footer">
    <!-- The "save and create another" option is blocked when editing an existing control config -->
    <span class:hidden={editId}>
      <Button
        type="primary"
        on:click={onSaveAndCreate}
        disabled={!isValidForm}
        {sending}
        name={sgettext("$$SAVE_CREATE_ANOTHER$$")} />
    </span>

    <Button
      type="default"
      on:click={onSaveAndClose}
      disabled={!isValidForm}
      {sending}
      name={sgettext("$$SAVE_CLOSE$$")} />
  </div>
</ModalBS3>
